import { Stack } from '@mui/material'
import { useMinimalsTheme } from '@tom-ui/ui'
import { CarrierType } from '@yard/app/api'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import {
  CarrierVisitOverviewCardDirectionItemProps,
  CarrierVisitOverviewCardDirections,
} from '../../molecules/CarrierVisitOverview/CarrierVisitOverviewCardDirections'
import { CarrierVisitOverviewCardHeader } from '../../molecules/CarrierVisitOverview/CarrierVisitOverviewCardHeader'

type Props = {
  name: string
  carrierType: CarrierType
  visitTimestamp: string
  statusChip?: React.ReactNode
  indicators: CarrierVisitOverviewCardDirectionItemProps[]
}

export const CarrierVisitOverviewCard: FC<Props> = observer(props => {
  const { name, carrierType, statusChip, visitTimestamp, indicators } = props
  const theme = useMinimalsTheme()

  return (
    <Stack
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius,
        boxShadow: theme.customShadows?.z1,
      }}
    >
      <CarrierVisitOverviewCardHeader
        name={name}
        carrierType={carrierType}
        statusChip={statusChip}
        visitTimestamp={visitTimestamp}
      />

      <Stack>
        <CarrierVisitOverviewCardDirections indicators={indicators} />
      </Stack>
    </Stack>
  )
})
